import React from 'react';
import { Typography } from '@coolremote/shared';
import { t } from 'ttag';
import useStyles from '../styles';
import WarningIcon from './WarningIcon';

/**
 * NoResults component displayed when discovery produces zero matching devices.
 *
 * @param {Object} props
 * @param {string} [props.message] - Custom warning message, replacing the default one
 * @param {Object} [props.scope] - Snapshot of what the finished run scanned
 * @param {string} [props.scope.deviceSerial] - Serial of the scanned device
 * @param {boolean} [props.scope.isSpecific] - Whether both a device and a line were chosen
 * @returns {React.ReactElement}
 */
const NoResults = ({ message, scope }) => {
  const classes = useStyles();

  const renderMessage = () => {
    if (message) {
      return message;
    }

    // Only a run scoped to both a device and a line can name that device
    const scopeLabel = scope?.isSpecific ? scope.deviceSerial : t`All`;

    return t`No devices were discovered for device ${scopeLabel}, please verify your BACnet device connection and click Discover button again`;
  };

  return (
    <div className={classes.noResultsContainer}>
      <div className={classes.warningBox}>
        <WarningIcon width={18} height={18} className={classes.warningIcon} />
        <Typography className={classes.warningText}>
          {renderMessage()}
        </Typography>
      </div>
    </div>
  );
};

export default NoResults;
